module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"signIn":"Войти"}}')
  delete Component.options._Ctor
}
